import { useState } from 'react';

import { Box, Collapse, Icon, Link, Td, Text, Tr, useColorModeValue } from '@ecoinvent/ui';
import { BiCommentDetail } from 'react-icons/bi';

import CopyToClipboardButton from 'components/shared/CopyToClipboardButton';
import { FlowDetailProperty } from 'hooks/data/datasets/V4/flows/types';
import { formatNumericalValue } from 'utilities/numbers';

type Props = {
  property: FlowDetailProperty;
  isExpanded: boolean;
  onToggleComment: () => void;
};

const PropertyRow = ({ property, isExpanded, onToggleComment }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  const bg = useColorModeValue('gray.100', 'gray.900');
  const tablesBg = useColorModeValue('white', 'gray.800');
  const commentColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <>
      <Tr
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        bg={isExpanded ? bg : undefined}
        sx={isExpanded ? { td: { borderBottom: 'none' } } : undefined}
      >
        <Td textAlign="left">
          <Text>{property.name}</Text>
        </Td>
        <Td textAlign="left">
          <Text>
            {formatNumericalValue(property.amount)}
            <CopyToClipboardButton value={property.amount} opacity={isHovered ? 1 : 0} ml={2} />
          </Text>
        </Td>
        <Td textAlign="left">
          <Text>{property.unit}</Text>
        </Td>
        <Td textAlign="right">
          {property.comment && (
            <Link
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              cursor="pointer"
              fontSize="sm"
              onClick={onToggleComment}
            >
              <Icon as={BiCommentDetail} mr={2} /> Comment
            </Link>
          )}
        </Td>
      </Tr>
      <Tr>
        {property.comment && (
          <Td
            px={4}
            pb={isExpanded ? 4 : 0}
            pt={0}
            colSpan={4}
            border={isExpanded ? 'auto' : 'none'}
            bg={isExpanded ? bg : undefined}
          >
            <Collapse in={isExpanded} unmountOnExit>
              <Box p={isExpanded ? 4 : 0} bg={tablesBg}>
                <Text fontSize="sm" whiteSpace="pre-wrap" color={commentColor}>
                  {property.comment}
                </Text>
              </Box>
            </Collapse>
          </Td>
        )}
      </Tr>
    </>
  );
};

export default PropertyRow;
